"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var $constants = _interopRequireWildcard(require("@/utils/constants"));
var _public = require("@/libs/public");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 权限判断函数

var tableForms = {
  page: 1,
  limit: $constants.page.limit[0],
  name: '',
  date: ''
};
var _default = exports.default = {
  name: 'SeckillList',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableForm: Object.assign({}, tableForms),
      name: '',
      fromList: this.$constants.fromList,
      merStarLevel: _jsCookie.default.get('merStarLevel')
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:seckill:activity:page'])) this.getList(1);
    if ((0, _permission.checkPermi)(['merchant:plat:product:category:cache:tree'])) this.$store.dispatch('product/getAdminProductClassify');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    goOn: function goOn(id) {
      this.$router.push({
        path: "/marketing/seckill/creatActivity/".concat(id)
      });
    },
    // 删除
    handleDelete: function handleDelete(id) {
      var _this = this;
      this.$modalSure("\u5220\u9664\u8BE5\u79D2\u6740\u6D3B\u52A8\u5417\uFF1F").then(function () {
        (0, _marketing.seckillAtivityDelApi)(id).then(function () {
          _this.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this.tableData.data.length, _this.tableForm);
          _this.getList();
        });
      });
    },
    handleReset: function handleReset() {
      this.tableForm = Object.assign({}, tableForms);
      this.name = '';
      this.getList(1);
    },
    // 列表
    getList: function getList(num) {
      var _this2 = this;
      this.tableForm.page = num ? num : this.tableForm.page;
      this.tableForm.name = encodeURIComponent(this.name);
      this.listLoading = true;
      (0, _marketing.seckillActivityListApi)(this.tableForm).then(function (res) {
        _this2.tableData.data = res.list;
        _this2.tableData.total = res.total;
        _this2.listLoading = false;
      }).catch(function (res) {
        _this2.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableForm.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableForm.limit = val;
      this.getList();
    }
  }
};